
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.781 16.359H20.4v8.183h10.983c-1.754 5.456-6.092 7.275-11.075 7.275-5.304.006-9.983-3.419-11.508-8.424-1.524-5.005.468-10.402 4.9-13.274 4.43-2.871 10.25-2.535 14.31.826l6.036-5.663c-6.685-6.06-16.642-7.006-24.38-2.317C1.93 7.654-1.705 16.836.77 25.448 3.244 34.059 11.224 40.003 20.308 40c11.196 0 21.32-7.274 19.473-23.641z","fill":"#FFF","fill-rule":"nonzero"}})])
          )
        }
      }
    